import { DefaultResponseWithData } from "./system";

export interface ICreateCheckoutSessionResponse extends DefaultResponseWithData<ICreateCheckoutSessionResponse> { }

export interface CreateCheckoutSessionResponse {
    sessionId: string;
    checkoutUrl: string;
}

export enum CheckoutSessionType {
    LookupToken,
    MySuperDuperCoolSubscription,
    SmsToken,
}